import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Home.css';
import QuestionList from '../QuestionList/QuestionList';
import { BASE_URL } from '../../utils/api';
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;
const categories = [
  'Django',
  'SQL',
  'React.js',
  'Java',
  'Node.js',
  'Cloud',
  'Python',
  'html',
  'css',
  'js',
  'ml',
  'C',
  'C++',
  'Data Analyst',
  'tableau',
  'Web Development',
  'Data Science',
  'Machine Learning',
  'Cybersecurity',
  'DevOps',
  'UI/UX Design',
  'Mobile App Development',
  'Ai',
  'Gen AI',
  'Agent AI',
  'Others',
];


const sortOptions = [
  { value: 'showall', label:'ShowAll'},
  { value: 'newest', label: 'Newest' },
  { value: 'mostReplies', label: 'Most Replies' },
  { value: 'unanswered', label: 'Unanswered' },
];

const Home = () => {
  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [selectedSort, setSelectedSort] = useState('newest');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const navigate = useNavigate();

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const res = await fetch(`${BASE_URL}/questions/`);
        if (res.ok) {
          const data = await res.json();
          setQuestions(data);
          setFilteredQuestions(data);
        } else {
          console.error('Failed to fetch questions');
        }
      } catch (err) {
        console.error('Error fetching questions:', err);
      }
    };

    fetchQuestions();
  }, []);

  // Filter and sort questions whenever selectedSort or selectedCategory changes
  useEffect(() => {
    let tempQuestions = [...questions];

    // Filter by category
    if (selectedCategory && selectedCategory !== 'all') {
      tempQuestions = tempQuestions.filter((q) =>
        q.tags?.toLowerCase().includes(selectedCategory.toLowerCase())
      );
    }

    // Sort
    if (selectedSort === 'newest') {
      tempQuestions.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      );
    } else if (selectedSort === 'mostReplies') {
      tempQuestions.sort(
        (a, b) => (b.replies?.length || 0) - (a.replies?.length || 0)
      );
    } else if (selectedSort === 'unanswered') {
      tempQuestions = tempQuestions.filter((q) => !q.replies || q.replies.length === 0);
    }

    setFilteredQuestions(tempQuestions);
  }, [selectedSort, selectedCategory, questions]);

  const handleAskQuestion = () => {
    navigate('/dashboard/ask-question');
  };

  return (
    <div className="container mx-auto py-6 space-y-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <CardTitle className="text-2xl font-bold">Forums</CardTitle>
          <Button onClick={handleAskQuestion}>
          Ask a Question
          </Button>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            Feel free to use this forum to ask questions and get your Answers
          </p>
        </CardContent>
      </Card>

      <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
        <div className="w-full sm:w-[200px]">
          <Select value={selectedSort} onValueChange={setSelectedSort}>
            <SelectTrigger>
              <SelectValue placeholder="Sort by" />
            </SelectTrigger>
            <SelectContent>
            {sortOptions.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>
                {opt.label}
                </SelectItem>
            ))}
            </SelectContent>
          </Select>
        </div>

        <div className="w-full sm:w-[200px]">
          <Select value={selectedCategory} onValueChange={setSelectedCategory}>
            <SelectTrigger>
              <SelectValue placeholder="Select category" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">All Categories</SelectItem>
            {categories.map((cat) => (
                <SelectItem key={cat} value={cat}>
                {cat}
                </SelectItem>
            ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      <QuestionList questions={filteredQuestions} />
    </div>
  );
};

export default Home;
